var React = require('react');

function HeroElement (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"12","width":"22","height":"22","fill":"#262556","key":0}),React.createElement("rect",{"x":"56","y":"22","width":"22","height":"22","fill":"#B58CFF","key":1}),React.createElement("rect",{"x":"34","width":"22","height":"22","fill":"#262556","key":2}),React.createElement("rect",{"y":"44","width":"22","height":"22","fill":"#FFFFFF","key":3})]);
}

HeroElement.defaultProps = {"width":"78","height":"66","viewBox":"0 0 78 66","fill":"none"};

module.exports = HeroElement;

HeroElement.default = HeroElement;
